var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blue-sky-st-bg" }, [
    _c("div", { staticClass: "blue-sky-st" }, [
      _c("img", {
        staticClass: "coupons-image",
        attrs: { src: require("./static/coupons.png") }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bind-mobile" },
        [
          _c("van-field", {
            staticClass: "field",
            attrs: { label: "", placeholder: "绑定手机号码领取" },
            model: {
              value: _vm.mobile,
              callback: function($$v) {
                _vm.mobile = $$v
              },
              expression: "mobile"
            }
          }),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "button",
              attrs: { icon: "star-o", color: "#ea0835", type: "primary" },
              on: { click: _vm.bindBobile }
            },
            [_vm._v("立即领取")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("img", {
        staticClass: "coupons-image",
        attrs: { src: require("./static/coupons-card.png") }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "use-mark" }, [
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("优惠券有效期")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v("有效期至2020年08月01日。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("使用条件")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v("领取优惠券后指定教练员和班型使用。")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "use-mark-item" }, [
        _c("span", { staticClass: "use-mark-item-title" }, [
          _vm._v("使用限制")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "use-mark-item-detail" }, [
          _vm._v(
            "该优惠券只适用于部分教练员，领取成功后指定教练员会及时联系您。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34976a1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34976a1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue
// module id = null
// module chunks = 